import React from "react";

import type { TextFieldProps } from "@atlaskit/textfield";
import ATextArea from "@atlaskit/textarea";

export const TextArea: React.FC<TextFieldProps & any> = React.forwardRef((props, ref) => (
  <ATextArea {...(props as any)} ref={ref} />
));

export type { TextFieldProps as TextAreaProps };
